import './App.css';
import React, {useState} from "react";
import MUIDataTable, { TableFilterList } from "mui-datatables";
import { saveAs } from 'file-saver'
import { write, utils } from 'xlsx'
import axios from "axios";
import { api, legacyPhpUrl } from "./api/client";
import {adaptV4Theme, createTheme, ThemeProvider} from '@mui/material/styles';
import Button from '@mui/material/Button';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EditIcon from '@material-ui/icons/Edit';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CancelIcon from '@mui/icons-material/Cancel';
import EditRoadIcon from '@mui/icons-material/EditRoad';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import moment from "moment";
import ReplayIcon from "@mui/icons-material/Replay";
import ModalBoxOnayla from "./ModalboxOnayla";
import ModalboxReddedilen from "./ModalboxReddedilen";
import MalzemeListesiOnizleme from "./MalzemeListesiOnizleme";
import IconButton from "@mui/material/IconButton";
import { Dialog,DialogActions, DialogContent, DialogContentText, DialogTitle, TextField} from "@material-ui/core";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import trLocale from "date-fns/locale/tr";
import {DatePicker} from "@mui/lab";
import ModalboxEkler from "./ModalboxEkler";
import Tooltip from '@mui/material/Tooltip';
import { enhanceColumns, withTableOptions } from "./utils/tableDisplay";
import { parseListResponse, buildPageParams, withServerSideOptions, makeServerTableHandler } from "./utils/serverSideTable";
import { applyFilterFacets, fetchTeklifFilterOptions } from "./utils/filterFacets";
import { formatTeklifTipi, TEKLIF_TIP_FILTER_NAMES } from "./utils/teklifTipi";

class OnayBekleyenler extends React.Component {
    constructor(props) {
        super(props);
        this.state={ filterOpts: {}, count: 0, page: 0, rowsPerPage: 50, search: '', filters: {}, replace: "", datas:[], open:false, id:""};
    }
    async getDatas(){
        const pageParams = buildPageParams({
            page: this.state.page,
            rowsPerPage: this.state.rowsPerPage,
            search: this.state.search,
            filters: this.state.filters,
            sortBy: this.state.sortBy,
            sortDir: this.state.sortDir,
            extra: {},
        });


        const res = await api.get('/teklifler/durum/onay_bekleyen', { params: pageParams })
        const { items: data, count } = parseListResponse(res)

        const products = data.map(d => ({
            "id":d.id ,
            "teklif_no" :  d.teklif_no,
            "teklif_tarihi":d.teklif_tarihi ,
            "teslim_tarihi" : d.son_teslim_tarihi ,
            "gecerlilik_tarihi" : d.gecerlilik_tarihi ,
            "musteri" :  d.musteri,
            "lokasyon": d.lokasyon,
            "uyf_no" :  d.uyf_no,
            "seri_no" :  d.seri_no,
            "makine" :  d.makine,
            "dosya_bir": d.dosya_bir,
            "dosya_iki" : d.dosya_iki,
            "dosya_uc" : d.dosya_uc,
            "temsilci": d.temsilci,
            "teklif_dili":d.teklif_dili,
            "dosya_var":d.dosya_var,
            "msn": d.musteri_siparis_no || "",
            "tip": formatTeklifTipi(d.teklif_tipi || (d.sozlesme ? 'sozlesme' : 'teklif')),
        }))
        //console.log(products);
        this.setState({ datas: products, count })

    }
    async hazirlananlaraGeriAl(value,correct) {
        if(correct) {


        await api.post('/teklifler/' + value + '/hazirlanana-geri-al', {})
            .then((response) => {
                // Success 🎉
                console.log(response);
                toast.success("Hazırlananlara geri alma işlemi başarılı");
                this.getDatas(true);
                this.setState({open:false})
            })
            .catch((error) => {
                // Error 😨
                if (error.response) {
                    /*
                     * The request was made and the server responded with a
                     * status code that falls out of the range of 2xx
                     */
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                    window.location.reload();
                } else if (error.request) {
                    /*
                     * The request was made but no response was received, `error.request`
                     * is an instance of XMLHttpRequest in the browser and an instance
                     * of http.ClientRequest in Node.js
                     */
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request and triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);
            });

        }
        }
    async onayla(value) {

        await api.post('/teklifler/' + value + '/onayla', {})
            .then((response) => {
                // Success 🎉
                console.log(response);
                 toast.success("Onaylama işlemi başarılı");
                const { datas } = this.state;
                datas.shift();
                this.setState({ datas });
            })
            .catch((error) => {
                // Error 😨
                if (error.response) {
                    /*
                     * The request was made and the server responded with a
                     * status code that falls out of the range of 2xx
                     */
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                    window.location.reload();

                } else if (error.request) {
                    /*
                     * The request was made but no response was received, `error.request`
                     * is an instance of XMLHttpRequest in the browser and an instance
                     * of http.ClientRequest in Node.js
                     */
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request and triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);
            });
    }

    async reddet(value) {

        await api.post('/teklifler/' + value + '/iptal', {})
            .then((response) => {
                // Success 🎉
                console.log(response);
                toast.success("Teklif iptal edilenler arasına taşındı");
                const { datas } = this.state;
                datas.shift();
                this.setState({ datas });
                window.location.reload();

            })
            .catch((error) => {
                // Error 😨
                if (error.response) {
                    /*
                     * The request was made and the server responded with a
                     * status code that falls out of the range of 2xx
                     */
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    /*
                     * The request was made but no response was received, `error.request`
                     * is an instance of XMLHttpRequest in the browser and an instance
                     * of http.ClientRequest in Node.js
                     */
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request and triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);
            });
    }


    
    async loadFilterOptions() {
        try {
            const opts = await fetchTeklifFilterOptions('onay_bekleyen');
            this.setState({ filterOpts: { ...opts, tip: TEKLIF_TIP_FILTER_NAMES } });
        } catch (e) {
            console.warn('filter options', e);
        }
    }

    componentDidMount() {
        this.loadFilterOptions();
        this.getDatas(true);
    }
    componentDidUpdate(prevProps,prevState,snapshot) {

            //this.getDatas(true);


    }

    onaylananlara = (data) => {
        this.getDatas();
        toast.success("Onaylananlar aşamasına geçme işlemi başarılı");

    }
    reddedilmis = (data) => {
        window.location.reload()
    }
    handleClose() {
        this.setState({open:false})
    }
    eklerBodyRender = (value, meta) => {

        const record = this.state.datas[meta.currentTableData[meta.rowIndex].index];

        if (value) {
            return (
                <ModalboxEkler key={meta.rowIndex} teklifNo={record.teklif_no}  dosyaVar={record.dosya_var} />
            );
        }

        return null; // Or other fallback content
    };
    render() {
        const theme  = createTheme(adaptV4Theme({
            overrides: {
                MUIDataTableHead:{
                    root:{
                        lineHeight:0.5,
                        maxHeight:"10px",
                        padding:0
                    }
                },
                MUIDataTableBodyRow: {
                    root: {
                        '&:nth-child(odd)': {
                            backgroundColor: '#eee'
                        },
                        '&:nth-child(even)': {
                            backgroundColor: '#fff'
                        },
                        lineHeight: 1,
                        padding:1
                    },
                },
                MuiTableCell: {
                    head: {
                        backgroundColor: "#e59e53 !important",
                        fontWeight: "bold",
                        padding:5
                    },
                    root: {
                        lineHeight:1
                    }
                },

            },
        }));
        Date.prototype.addDays = function (days) {
            let date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
        }
        const columns = [
            {
                name: "id",
                label: "İşlemler",
                options: {
                    filter: false,
                    sort: false,
                    setCellProps: () => ({ style: { whiteSpace: 'nowrap', width: 1 } }),
                    customBodyRender: (value, tableMeta) => {
                        const record = data[tableMeta.currentTableData[tableMeta.rowIndex].index];
                        const teklifNo = record.teklif_no;
                        return (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'nowrap' }}>
                                {teklifNo && (
                                    <Tooltip title="Kopyala"><span>
                                        <IconButton size="small" href={'/teklif-kopyala/' + teklifNo} color={'warning'} variant="outlined" target="_blank">
                                            <ContentCopyIcon />
                                        </IconButton>
                                    </span></Tooltip>
                                )}
                                {teklifNo && (
                                    <Tooltip title="Revize Et"><span>
                                        <IconButton size="small" href={'/teklif-revize/' + teklifNo} color={'warning'} variant="outlined" target="_blank">
                                            <EditRoadIcon />
                                        </IconButton>
                                    </span></Tooltip>
                                )}
                                {value && (
                                    <ModalBoxOnayla id={record.id} teklifNo={record.teklif_no} onaylananlara={this.onaylananlara} />
                                )}
                                {value && (
                                    <Tooltip title="Geri Al"><span>
                                        <IconButton size="small" onClick={() => { this.setState({ id: value, open: true }); }} color={"secondary"} variant="outlined">
                                            <ReplayIcon />
                                        </IconButton>
                                    </span></Tooltip>
                                )}
                                <ModalboxReddedilen id={record.id} reddEdilmis={this.reddedilmis} />
                            </div>
                        );
                    },
                },
            },
            {
                name: "teklif_no",
                label: "Teklif No",
                options: {
                    filter: false,
                    customBodyRender: (value, meta, updateValue) => {
                        if (value) {
                            const record = data[meta.currentTableData[meta.rowIndex].index];
                            return (
                                <MalzemeListesiOnizleme teklifNo={value} teklifDili={record.teklif_dili} teklifTarihi={record.teklif_tarihi} musteri={record.musteri}/>
                            );

                        }
                    },
                    customFilterListOptions: { render: v => `Teklif NO: ${v}` },
                },
            },
            {
                name: "msn",
                label: "MSN",
                options: { filter: false, sort: false },
            },
            {
                name: "tip",
                label: "Tip",
                options: { filter: true, sort: true },
            },
            {
                name: "teklif_tarihi",
                label: "Teklif Tarihi",
                options: {
                    filter: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value) {
                            return (
                                moment(new Date(value)).format('DD/MM/yyyy')
                            );

                        }
                    },
                },
            },
            {
                name: "gecerlilik_tarihi",
                label: "Geçerlilik Tarihi",
                options: {
                    filter: false,
                    filterOptions: {
                        fullWidth: true
                    },
                    customBodyRender: (value) => {
                        if (value) {
                            return moment(new Date(value)).format('DD/MM/yyyy');
                        }
                        return '';
                    },
                }
            },
            {
                name: "musteri",
                label: "Müşteri",
                options: {
                    filter: true,
                    filterOptions: {
                        fullWidth: true
                    },
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value) {
                            return (
                                value.substring(0, value.indexOf(' '))
                            );

                        }
                    }
                }
            },
            {
                name: "lokasyon",
                label: "Lokasyon",
                options: {
                    /*customBodyRenderLite: (dataIndex) => {
                        let val = data[dataIndex][3];
                        return val;
                    },*/
                    filter: false,
                }
            },
            {
                name: "makine",
                label:"Makine",
                options: {
                    filter: false,
                    //customFilterListOptions: { render: v => `Salary: ${v}` },
                    sort: false
                }
            },
            {
                name: "uyf_no",
                label:"UYF No",
                options: {
                    filter: true,

                    filterOptions: {
                        fullWidth: true
                    },

                    //customFilterListOptions: { render: v => `Salary: ${v}` },
                    sort: false
                }
            },   {
                name: "seri_no",
                label:"Seri No",
                options: {
                    filter: true,

                    filterOptions: {
                        fullWidth: true
                    },

                    //customFilterListOptions: { render: v => `Salary: ${v}` },
                    sort: false
                }
            },
            {
                name: "temsilci",
                label:"Temsilci",
                options: {
                    filter: true,
                    filterOptions: {
                        fullWidth: true
                    },

                    //customFilterListOptions: { render: v => `Salary: ${v}` },
                    sort: false
                }
            },
            {
                name: "teklif_no",
                label:"Ek",
                options: {
                    filter:false,
                    customBodyRender: (value, meta, updateValue) => {

                        return (
                            this.eklerBodyRender(value,meta)
                        );


                    },
                    sort:false,
                }
            },



        ];
        const data =  this.state.datas;

        let datas=[];
        const options = {
            sortOrder: { name: "teklif_tarihi", direction: "asc" },
            filter: true,


            selectableRows: 'none',
            filterType: 'multiselect',
            responsive: "vertical",
            rowsPerPage: this.state.rowsPerPage,
            fixedHeader: true,
            //fixedSelectColumn: true,
            tableBodyHeight: '100%',
            print:false,
            download:true,
            searchOpen:false,
            draggableColumns: {
                enabled:false,
                transitionTime:400
            },
            rowStyle: {
                fontSize: 9,
                lineHeight:0.1
            },
            downloadOptions: {
                filterOptions: {
                    useDisplayedColumnsOnly: true,
                    useDisplayedRowsOnly: true
                }
            },
            onRowSelectionChange : (curRowSelected, allRowsSelected) => {
                datas.length=0;
                console.log("---RowSelect")
                console.log("Row Selected: ", curRowSelected);
                console.log("All Selected: ", allRowsSelected);

                if(allRowsSelected) {
                    allRowsSelected.forEach((result)=>{
                        datas.push(data[result.dataIndex]);
                    })
                }
            },
            textLabels :{
                body: {
                    noMatch: "Bu tabloda hiç bir veri yok",
                    toolTip: "Sırala",
                    columnHeaderTooltip: column => `${column.label} için sırala`
                },
                selectedRows: {
                    text: "satır seçildi",
                    delete: "SiparişeEkle",
                    deleteAria: "Seçilenleri siparişe aktar",
                },
                pagination: {
                    next: "İleri",
                    previous: "Geri",
                    rowsPerPage: "Sayfadaki satır sayısı:",
                    displayRows: "/",
                },
                toolbar: {
                    search: "Ara",
                    downloadCsv: "XLSX İndir",
                    print: "Çıktı Al",
                    viewColumns: "Sütunları Göster",
                    filterTable: "Tabloyu Süz",
                },
                filter: {
                    all: "Tümünü Göster",
                    title: "Filtreler",
                    reset: "Sıfırla",
                },
                viewColumns: {
                    title: "Sütunları Göster",
                    titleAria: "Sütunları Göster/Gizle",
                },

            },
            onDownload: (buildHead, buildBody, columns, values) => {
                const fileType =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                const fileExtension = ".xlsx";

                console.log(values.forEach(val => console.log(val)));

                const json = values.reduce((result, val) => {
                    const temp = {};
                    val.data.forEach((v, idx) => {
                        temp[columns[idx].name] = v;
                    });
                    result.push(temp);
                    return result;
                }, []);

                const fileName = `Onay Bekleyen Teklif Listesi`;
                const ws = utils.json_to_sheet(json);
                const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
                const data = new Blob([excelBuffer], { type: fileType });
                saveAs(data, fileName + fileExtension);
                // cancel default  CSV download from table
                return false;
            },

        };

        return (

            <ThemeProvider theme={theme}>


                <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover

                />
                <MUIDataTable title={"Onay Bekleyen Teklifler"} data={data} columns={enhanceColumns(applyFilterFacets(columns, this.state.filterOpts))} options={withTableOptions(withServerSideOptions(options, {
                    count: this.state.count,
                    page: this.state.page,
                    rowsPerPage: this.state.rowsPerPage,
                    sortBy: this.state.sortBy,
                    sortDir: this.state.sortDir,
                    onServerTableChange: makeServerTableHandler(this),
                }))} />
                <Dialog
                    open={this.state.open}
                    onClose={()=>{this.handleClose(true)}}
                    aria-labelledby="form-dialog-title"
                    maxWidth="md"
                >
                <DialogTitle id="form-dialog-title">Hazırlananlara Geri Gönder</DialogTitle>
                <DialogContent>
                Onaylıyor musunuz?
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>{this.handleClose(true)}} color="primary">
                        İptal
                    </Button>
                    <Button

                        onClick={ ()=>{ this.hazirlananlaraGeriAl(this.state.id,true).then(r=>console.log(r)) }}
                        color="primary"
                    >
                        Gönder
                    </Button>
                </DialogActions>
            </Dialog>


            </ThemeProvider>
        );

    }


}

export default OnayBekleyenler;
